'use strict';

import _ from 'lodash';

export default function() {
  return {
    controller: function($scope, $http, $sce, $interval) {
      'ngInject';

      $scope.index = 0;

      $scope.testimonials = [];

      $scope.current = [];

      $scope.class = "ToLeft";

      $scope.$watch("index", UpdateCurrent);

      var interval = $interval(function() {
        $scope.class = "ToLeft";
        $scope.index += 3;
        if($scope.index >= $scope.testimonials.length) {
          $scope.index -= $scope.testimonials.length;
        }
      }, 8000);

      function UpdateCurrent() {
        if($scope.testimonials.length == 0)
          return [];
        $scope.current = [];
        for(var i = $scope.index; i < $scope.index + 3; i++) {
          if(i < $scope.testimonials.length) {
            $scope.current.push(angular.copy($scope.testimonials[i]));
          } else {
            $scope.current.push(angular.copy($scope.testimonials[i - $scope.testimonials.length]));
          }
        }
      }

      $scope.Left = function Left() {
        $scope.class = "ToRight";
        $scope.index -= 3;
        if($scope.index < 0) {
          $scope.index += $scope.testimonials.length;
        }
        $interval.cancel(interval);
      };

      $scope.Right = function Right() {
        $scope.class = "ToLeft";
        $scope.index += 3;
        if($scope.index >= $scope.testimonials.length) {
          $scope.index -= $scope.testimonials.length;
        }
        $interval.cancel(interval);
      };

      function _getLogos() {
        $http({
          url: '/api/testimonial/gettestimonials',
          method: 'get',
          params: { tag: $scope.element.data.tag, includeCompany: true}
        })
          .then(function Success(result) {
            $scope.testimonials = result.data;
            UpdateCurrent();
          }, function Fail(result) {
            console.log("Get Testimonials Failed: " + result);
          })
      }

      $scope.Go = function Go(url) {
        document.location = url;
      };

      _getLogos();
      //$scope.$watch("element.data.gray", _getLogos);

    },
    template: require('./testimonialcirclefeature.html')
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/testimonialcirclefeature.js